import { ResetPasswordForm } from "@/components/reset-password-form"

export const ResetPasswordPage = () => {
  return <ResetPasswordForm />
}
